import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'How fast will I see results?',
    a: 'Most clients start getting meetings in the first 30 days. Revenue usually follows 60\u201390 days after that. Every business is different, but we set clear expectations on day one.',
  },
  {
    q: 'What do you need from me?',
    a: 'A few calls to set things up. After that, just show up to the meetings we book for you and close deals.',
  },
  {
    q: 'How is this different from hiring an agency?',
    a: 'Agencies give you reports and "leads." We give you customers and revenue. No dashboards, no jargon \u2014 just meetings on your calendar and money in your bank.',
  },
  {
    q: 'What does the commitment look like?',
    a: 'We ask our clients to commit. That\u2019s how real results happen \u2014 both sides invested, both sides accountable. The specifics depend on the service, and we\u2019ll walk through everything on our strategy call.',
  },
  {
    q: 'What if Outbound as a Service doesn\u2019t work?',
    a: 'We guarantee you\u2019ll triple your pipeline in 6 months. If you don\u2019t, we work for free until you do. We put our money where our mouth is.',
  },
  {
    q: 'How does NIMBLE pricing work?',
    a: 'There are 4 ways to work with us on NIMBLE: a fixed rate of $2,500/month, an incremental model that starts lower and increases a set amount each month, a progressive model that increases when you hit specific revenue benchmarks, or a performance model with a lower base plus revenue share when you close business. We\u2019ll figure out which fits best on our call.',
  },
  {
    q: 'What industries do you work with?',
    a: 'Financial services, insurance, SaaS, marketing agencies, and sales training. If you sell to businesses and your deals are worth $5K+, we can probably help.',
  },
  {
    q: 'Who is NIMBLE best for?',
    a: 'B2B companies with 5 to 50 employees. If you\u2019re a solopreneur, book a call anyway \u2014 we\u2019ll point you toward the right service for your situation.',
  },
  {
    q: 'How does the outbound calling work?',
    a: 'We call your prospects for you. When someone is interested, we book a meeting on your calendar. You never have to cold call again.',
  },
  {
    q: 'Can you work with my CRM?',
    a: 'Most likely. We work with all major CRMs. If yours is unusual, we\u2019ll figure it out or suggest something better.',
  },
  {
    q: 'How do I get started?',
    a: 'Book a strategy call. We\u2019ll learn about your business, show you exactly how we can help, and get moving in days \u2014 not months.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" data-testid="faq-section" className="section" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="container max-w-3xl">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-4">Questions? We've Got Answers.</h2>
          <p className="text-base md:text-lg" style={{ color: 'var(--text-secondary)' }}>
            No jargon. No runaround. Just straight answers.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl border border-gray-100 overflow-hidden transition-all duration-200"
              style={{ backgroundColor: openIndex === i ? 'var(--bg-secondary)' : 'var(--bg-primary)' }}
              data-testid={`faq-item-${i}`}
            >
              <button
                className="w-full flex justify-between items-center px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                aria-expanded={openIndex === i}
                aria-controls={`faq-a-${i}`}
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-semibold pr-4" style={{ color: 'var(--text-primary)' }}>
                  {faq.q}
                </span>
                <ChevronDown
                  className="w-5 h-5 flex-shrink-0 transition-transform duration-200"
                  style={{
                    color: 'var(--brand-primary)',
                    transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
              </button>
              {openIndex === i && (
                <div id={`faq-a-${i}`} className="px-6 pb-5">
                  <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
